<template lang="html">
    <div>
        <!-- Top bar-->
        <pipeline-header/>
        <!-- Begin Page Content -->
        <components v-bind:is="Content" v-on:change-view="goPage" :properties="properties" />
    </div>
</template>

<script>
    import Header from '@/views/Common/Header.vue'
	import List from '@/views/Common/List.vue'
	import Create from '@/views/Analysis/Pipeline/Detail.vue'
	
    export default {
        name: 'Pipeline',
        components: 
        {
            'pipeline-header': Header,
			'pipeline-content': List,
            'pipeline-create': Create
        },
        created () {
            this.$axios.defaults.headers.common['x-access-token'] = this.$store.getters.getAccessToken;
            this.$axios.defaults.headers.common['x-refresh-token'] = this.$store.getters.getRefreshToken;
            
        },
        mounted(){
			//화면 새로고침시 기존 화면 불러오기
			if(this.$route.params.mid){
                this.goPage({'mid':this.$route.params.mid, 'type':this.$route.params.type});
			}else{
                this.goPage({'mid':sessionStorage.mid, 'type':sessionStorage.type});
			}
        },
        data () {
            return {
                Content: '',
                properties:[],
                menuHeaders:[]
            }
        },
        methods: {
            goPage(data){
                this.Content = 'pipeline-content';
                this.properties = data;
                sessionStorage.removeItem('type');
                sessionStorage.removeItem('mid');
                sessionStorage.setItem('type', data.type);
                sessionStorage.setItem('mid',data.mid);
            },
            reissueToken (err) {
                const previos = err.response.config.url;
                if (err.response.status === 401) {
                    this.$axios.get(this.$apiHost+'/auth/reissuance')
                        .then(res => {
                            cookieJs.set('accessToken', res.data.data.accessToken);
                            this.$axios.defaults.headers.common['x-access-token'] = cookieJs.get('accessToken');
                            this.$axios.get(this.$apiHost+'/board')
                                .then(res => {
                                    console.log(res);
                                });
                        });
                }
            },
            trigger (data) {
                this.goPage(data);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/Analysis/Pipeline/Pipeline.vue